import { render, staticRenderFns } from "./RetailerInsights.vue?vue&type=template&id=bdf7549a&"
import script from "./RetailerInsights.vue?vue&type=script&lang=js&"
export * from "./RetailerInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf7549a')) {
      api.createRecord('bdf7549a', component.options)
    } else {
      api.reload('bdf7549a', component.options)
    }
    module.hot.accept("./RetailerInsights.vue?vue&type=template&id=bdf7549a&", function () {
      api.rerender('bdf7549a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/RetailerInsights.vue"
export default component.exports